import React, { memo, useCallback } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import ToolTip from 'design-system/ToolTip';
import useColors from 'hooks/useColors';
import { InfoModal } from './InfoModal';
import { isWeb } from '../../../constants';
const AboutInfoColumn = ({ right, title, info, toolTipTitle, toolTipDescription }) => {
    const colors = useColors();
    const onPress = useCallback(() => {
        InfoModal.show(toolTipTitle, toolTipDescription);
    }, [toolTipDescription, toolTipTitle]);
    // On web the explanation shows on hover over the icon rather than in a modal
    if (isWeb) {
        return (<View style={[styles.container, right && styles.alignRight]}>
        <Text Numbers-16 flex numberOfLines={1}>
          {info || '-'}
        </Text>
        <View style={styles.titleContainer}>
          <Text TextThin-14 Gray numberOfLines={1}>
            {title}
          </Text>
          <Spacer w={6}/>
          <ToolTip small colorKey="secondary" title={toolTipTitle} subtitle={toolTipDescription}/>
        </View>
      </View>);
    }
    return (<TouchableOpacity style={[styles.container, right && styles.alignRight]} onPress={onPress}>
      <Text Numbers-16 flex numberOfLines={1}>
        {info || '-'}
      </Text>
      <View style={styles.titleContainer}>
        <Text TextThin-14 Gray numberOfLines={1}>
          {title}
        </Text>
        <Spacer w={6}/>
        <IconTooltip width={16} height={16} color={colors.text.secondary}/>
      </View>
    </TouchableOpacity>);
};
export default memo(AboutInfoColumn);
const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: rem(16),
    },
    alignRight: {
        alignItems: 'flex-end',
    },
    titleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
